import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { StoreModule } from "@ngrx/store";
import * as fromSnowflakeState from "./reducer";
import { EffectsModule } from "@ngrx/effects";
import { SnowflakeEffects } from "./effects";

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        StoreModule.forFeature(
            fromSnowflakeState.snowflakeStateFeatureKey,
            fromSnowflakeState.snowflakeReducer,
        ),
        EffectsModule.forFeature([SnowflakeEffects]),
    ],
})
export class SnowflakeModule {}
